import type { JSX } from 'react'
import type { IDropdownProps } from '../Dropdown'

import { ButtonFonts } from 'atoms/Button'
import { DropdownItemsGroupLanguage } from 'blocks/Dropdown/DropdownItemsGroup/Templates/DropdownItemsGroupLanguage'
import { DropdownLanguageSC } from 'blocks/Dropdown/Templates/DropdownLanguage.styled'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { DropdownAlignment, DropdownPosition } from '../Dropdown.h'
import { DropdownHeaderLanguage } from '../DropdownHeader/Templates'

/** Language picker. Skin `content` is ignored; the trigger always mounts. */
export interface IDropdownLanguageProps extends IDropdownProps {
  title?: string
  dataTestIdBtn?: string
  dataTestIdList?: string
  position?: DropdownPosition
  positionOffset?: FIXED_INDENTS
  headFont?: ButtonFonts
  menuHeight?: number
}

export const DropdownLanguage = ({
  title = '',
  dataTestIdBtn,
  dataTestIdList,
  position = DropdownPosition.Bottom,
  positionOffset = FIXED_INDENTS.INDENT_90,
  children,
  headFont = ButtonFonts.FontSmBold,
  menuHeight = 320,
  // Accepted from skins (`content: $languages`) but ignored: this template
  // always mounts. Dropdown would unmount a 0–1 item list.
  content: _content,
  ...rest
}: IDropdownLanguageProps): JSX.Element => {
  return (
    <DropdownLanguageSC
      alignment={DropdownAlignment.Right}
      position={position}
      positionOffset={positionOffset}
      {...rest}
      content
    >
      <DropdownHeaderLanguage
        title={title}
        dataTestId={dataTestIdBtn}
        font={headFont}
      />
      <DropdownItemsGroupLanguage
        dataTestId={dataTestIdList}
        height={menuHeight}
      >
        {children}
      </DropdownItemsGroupLanguage>
    </DropdownLanguageSC>
  )
}
